import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import "./assets/js/rem";
import './icons' // icon
import Vant from "vant";
import { Toast, Dialog } from "vant";
import FastClick from "./utils/fastClick.js";
import "./assets/css/common.scss";
import "vant/lib/index.css";
import VeeValidate from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import VueI18n from "vue-i18n";
import setIosTitle from "@/assets/js/setIosTitle";
import AxPanel from "@/components/common/AxPanel.vue";
import AxExpPanel from "@/components/common/AxExpPanel.vue";
import AxFold from "@/components/common/AxFold.vue";
import AxResultPage from "@/components/common/AxResultPage.vue";
import AxDownItem from "@/components/common/AxDownItem.vue";
import AxSelect from "@/components/common/AxSelect.vue";
import AxTags from "@/components/common/AxTags.vue";
import AxHead from "@/components/common/AxHead.vue";
import AxExpStep from "@/components/common/AxExpStep.vue";
import AxStep from "@/components/common/AxStep.vue";
import SuspendButton from "@/components/common/SuspendButton.vue";
// import VConsole from 'vconsole'
// if (process.env.NODE_ENV != "production") {
//   const vConsole = new VConsole()
//   Vue.use(vConsole)
//  }

import filterFn from "./utils/filter"; // filter
filterFn(Vue);

Vue.component("result", AxResultPage);
Vue.component("ax-select", AxSelect);
Vue.component("ax-tags", AxTags);
Vue.component("ax-head", AxHead);
Vue.component("ax-result-page", AxResultPage);
Vue.component("ax-panel", AxPanel);
Vue.component("ax-exp-panel", AxExpPanel);
Vue.component("ax-fold", AxFold);
Vue.component("ax-step", AxStep);
Vue.component("ax-exp-step", AxExpStep);
Vue.component("ax-down", AxDownItem);
Vue.component("suspend-button", SuspendButton);

Vue.use(Vant);

Toast.allowMultiple();
Vue.prototype.$toast = Toast;
Dialog.setDefaultOptions({
  cancelButtonColor: "#888",
  confirmButtonColor: "#4287fe"
});
Vue.prototype.$dialog = Dialog;
Vue.prototype.$setIosTitle = setIosTitle;

/* 
 RUNNING("运行中", "green"),
    DRAFTED("草稿", "orange"),
    SUCCESS_END("成功结束", "blue"),
    DISCARD_END("作废", "red"),
    ABORT_END("异常中止结束", "red"),
    BACK_TO_END("拒绝", "red"),
    PENDING("挂起", "gray"),
    CANCEL_END("取消结束", "red"),
    REBACK("驳回", "red");
 */


Vue.prototype.approvalStatus = {
  A: "agree",
  D: "refuse",
  C: "revoke",
  S: "pend",
  I: "pend",
  undefined: "",
  null: "",
  SUCCESS_END: "agree",
  REBACK: "refuse",
  DISCARD_END: "discard",
  BACK_TO_END: "refuse",
  ABORT_END: "abort",
  RUNNING: "pend",
  PENDING: "pending",
  DRAFTED: 'draft'
};

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "zh_CN"
});
Vue.use(VeeValidate, {
  i18n,
  i18nRootKey: "validation",
  dictionary: {
    zh_CN
  }
});

const dictionary = {
  zh_CN: {
    messages: {},
    attributes: {
      fill: "法务回填",
      select: "是否回填"
    }
  }
};

VeeValidate.Validator.localize(dictionary);

// 解决300ms的延迟
if ("addEventListener" in document) {
  document.addEventListener(
    "DOMContentLoaded",
    function() {
      FastClick.attach(document.body);
    },
    false
  );
}

Vue.config.productionTip = false;

Vue.prototype.checkVersion = function() {
  let u = navigator.userAgent,
    type = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1 ? "1" : "2";
  this.$dialog
    .confirm({
      message: "当前版本过低，请更新至最新版本。",
      confirmButtonText: "去更新",
      className: "update-dialog",
      beforeClose: (action, done) => {
        if (action === "confirm") {
          if (type === "1") {
            iqh.doUpdate();
          } else {
            window.open(
              "https://apps.apple.com/cn/app/360/id1450482195",
              "_self "
            );
          }
          done();
        } else {
          done();
        }
      }
    })
    .catch(() => {});
};

// 设置合同地址
const locationHost = window.location.host;
if(~locationHost.indexOf('dev')  ){
  Vue.prototype.$contract_baseurl = 'http://10.16.125.129'
} else if(~locationHost.indexOf('uat') || ~locationHost.indexOf('localhost')){
  Vue.prototype.$contract_baseurl = 'http://10.16.101.66'
} else { // 线上
  Vue.prototype.$contract_baseurl = 'https://clm.corp.qihoo.net'
}



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

router.afterEach((to, from) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    setIosTitle(to.meta.title);
  }
});
